import { render, staticRenderFns } from "./NextAvailableAppointments.vue?vue&type=template&id=15a8dc12"
import script from "./NextAvailableAppointments.vue?vue&type=script&lang=js"
export * from "./NextAvailableAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports